/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ApptReminder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function ApptReminder({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/Emails/Content/Email/ApptReminder"
  
}) {
let emailIdValueData = fromData.useDataValue({ viewPath,
context: 'email',
path: 'id',
})
let profilePatientAppointmentRemindersValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'appointment_reminders',
})
let aggregateData = fromHelpers.isAppointmentReminder(emailIdValueData, profilePatientAppointmentRemindersValueData)
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="email.id"
 data="profile_patient.appointment_reminders"
 aggregate="helpers.js isAppointmentReminder"
 value={aggregateData}
 onChange={onChange}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Send appt. reminder"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}